import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {PopupController} from "../dashboard/lavazza/components/popup/PopupController";
import {
    EquipmentSettingsModel,
    PredefinedDestination as Destination,
    PredefinedMethod as Method,
    RequestInfo,
} from "./builder/models";

export const EquipmentSettingsPopupController = new PopupController();

export const EQUIPMENT_PRODUCT_STOCK_GUID = "acbcfc8e-ead0-47fa-8735-4c561ce785b1"

class Service {
    public getEquipmentSettingsSections = (ID: string): Promise<EquipmentSettingsModel> => {
        return new Promise<EquipmentSettingsModel>((resolve, reject) => {
            Ajax.ajaxRequestForJson({
                type: "GET",
                url: "equipment/" + ID + "/settings",
                success: resolve,
                error: reject,
            });
        });
    }

    public getEquipmentSectionContent = (request: RequestInfo): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            if (!request) {
                reject("No request info");
                return;
            }
            this.makeRequest(request, resolve, reject);
        });
    }

    public setParameterValue = (request: RequestInfo | any, value: any): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            if (!request) {
                reject("No request info");
                return;
            }

            request = {
                ...request,
                ...(request.valueBasedRequests || {})[(value || {})["0"]],
                params: {
                    ...request.params,
                    ...((request.valueBasedRequests || {})[(value || {})["0"]] || {}).params,
                },
            };

            if (request.method === Method.PATCH) {
                const params = {list: []};
                Object.keys(request.patchOperations).forEach((key) => {
                    const operation = request.patchOperations[key];
                    operation.value = value[key];
                    if (operation.value) {
                        params.list.push(operation);
                    }
                });
                request.params = params;
            } else {
                request.method = request.method || (request.destination === Destination.VEBOX ? "POST" : "PUT");
                Object.keys(request.paramsToSet).forEach((key) => {
                    // tslint:disable-next-line:radix
                    request.params[request.paramsToSet[parseInt(key)]] =
                        // tslint:disable-next-line:radix
                        value[parseInt(key)] || request.params[request.paramsToSet[parseInt(key)]];
                });
            }

            const mappedParams = Object.keys(request.mapParamNames || {}).reduce((a, x) => {
                return {
                    ...a,
                    [request.mapParamNames[x]]: request.params[x],
                    [x]: undefined,
                };
            }, {
                ...request.params,
            });

            request = {
                ...request,
                params: {
                    ...mappedParams,
                },
            };

            this.makeRequest(request, resolve, reject);
        });
    }

    public executeCommand = (request: RequestInfo): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (!request) {
                reject("No request info");
            }
            this.makeRequest(request, resolve, reject);
        });
    }

    private makeRequest = (request: RequestInfo, success, error) => {
        let restApi = RestDataLoader.loadData;

        switch (request.method) {
            case Method.DELETE:
                restApi = RestDataLoader.deleteJSON;
                break;
            case Method.PUT: {
                restApi = RestDataLoader.putJSON;
                break;
            }
            case Method.POST: {
                restApi = RestDataLoader.postJSON;
                break;
            }
            case Method.PATCH: {
                restApi = RestDataLoader.patchJSON;
                break;
            }
        }

        switch (request.destination) {
            case Destination.RESTAPI: {
                restApi(
                    setPathVariables(request.url, request.params, request.pathVariableToSet)
                    + objToUrlParams(request.urlParamsToSet, request.params),
                    request.params,
                    success,
                    error,
                );
                break;
            }
            case Destination.VEBOX: {
                Ajax.vbxAjax({
                    type: request.method || "POST",
                    url: request.url,
                    data: request.params,
                    success: (data, status, xhr) => success({data, status, xhr}),
                    error,
                });
                break;
            }
            default: {
                error("Destination is undefined");
            }
        }
    }

    public isReactComponent(guid: string): boolean {
        return [EQUIPMENT_PRODUCT_STOCK_GUID].findIndex(v => v === guid) > -1;
    }
}

function setPathVariables(url: string, params: any = {}, obj: any = {}): string {
    return Object.keys(obj).reduce((newUrl, key) => {
        return newUrl.replace("{" + key + "}", params[obj[key]]);
    }, url);
}

function objToUrlParams(paramNames: string[], obj: any): string {
    if (!paramNames) {
        return "";
    }
    return "?" + paramNames.reduce((acc, x) => {
        return acc + (acc !== "" ? "&" : "") + x + "=" + encodeURIComponent(obj[x] || "");
    }, "");
}

export const EquipmentSettingsService = new Service();
